import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "disk",
  "use": "disk-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"disk\"><title>icn/disk</title><path d=\"M14 9.764A2.989 2.989 0 0 0 12 9V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v4c-.768 0-1.47.289-2 .764V5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4.764zM4 10h8a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4zm8 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z\" id=\"disk_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol